export default async function ({$strapi, redirect}) {
  if ($strapi.user) {
    return redirect('/')
  }
}
